import { debounce, throttle } from '../utils/index'
import { reportDmpPop } from '../request/dmp'
import { dmpParams, dmpMutations } from '../store/dmp'
import { reportDmp } from '../request/dmp'

/**
 * dmp上报列表指令
 * @param {*} el 
 * @param {*} binding 
 */
export default function vDmp (el, binding) {
    if (!binding.value || !binding.value.action) return
    let actions = binding.value.action.replace(/ /g, '').split(',')
    let delayReport = debounce(reportDmpPop, dmpParams.DEBOUNCE_DELAY)
    let params = binding.value
    dmpMutations.removeEvents()
    actions.forEach((item, index) => {
        params.action = item
        // 区分action
        switch (item) {
        // 点击上报
        case 'click':
            params.hash = location.hash
            el.addEventListener('click', (e)=>{
                clickHandler(e)
            }, false)
            const clickHandler = (e) => {
                if (dmpParams.clickId != '') return
                dmpParams.clickId = params.targetid
                params.action = 'click'
                // 缓存点击相关数据
                dmpMutations.setCache(params, 'pv')
                reportDmp(params)
                removeClick()
                setTimeout(()=>{
                    dmpParams.clickId = ''
                },50)
            }
            const removeClick = () => {
                el.removeEventListener('click', clickHandler, false)
            }
            dmpParams.list_click_remove_events.push(()=>{
                removeClick()
            })
            break;

            // 曝光上报
        case 'pop':
            let listener = () => {
                
                
                // 判断是否处于可视区域
                if (el.className.indexOf('haspop') != -1) return
                let bodyHeight = screen.availHeight,
                    bodyWidth = screen.availWidth,
                    curTop = el.getBoundingClientRect().top,
                    curLeft = el.getBoundingClientRect().left;
                if (curTop && curTop <= bodyHeight && curLeft <= bodyWidth) {
                    // 添加到曝光队列
                    el.className += ' haspop'
                    dmpParams.list_dmp_multi_pop.push(params)
                    removPop()
                    delayReport()
                }
            }
            // 绑定scroll
            window.document.body.addEventListener('touchend', listener, true)
            setTimeout(listener,100)
            
            const removPop = () => {
                window.document.body.removeEventListener('touchend', listener, true)
            }
            dmpParams.list_pop_remove_events.push(()=>{
                removPop()
            })

            break;
        default:
            reportDmp(params)
        }
    })
}